import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../lib/query-keys';
import { financialService } from '../../services/financial.service';

export function useCostCodes(orgId: string | null) {
  return useQuery({
    queryKey: queryKeys.costCodes.all(orgId ?? ''),
    queryFn: () => financialService.getCostCodeItems(orgId!),
    enabled: !!orgId,
    staleTime: 5 * 60_000,
    select: (res: any) => Array.isArray(res.data) ? res.data : res.data?.data ?? [],
  });
}
